import { theme } from '@traba/theme'
import styled, { css } from 'styled-components'

interface LastUsedAuthContainerProps {
  $flex?: boolean
  $highlighted?: boolean
}

export const LastUsedAuthContainer = styled.div<LastUsedAuthContainerProps>`
  position: relative;
  width: ${({ $flex }) => ($flex ? 'auto' : '100%')};
  flex: ${({ $flex }) => ($flex ? 1 : 'none')};

  ${({ $highlighted, theme }) =>
    $highlighted &&
    css`
      & > button {
        outline: 2px solid ${theme.colors.Violet};
        outline-offset: 2px;
      }
    `}
`

export const LastUsedAuthBadge = styled.span<{ $inverted?: boolean }>`
  position: absolute;
  top: -8px;
  right: 8px;
  z-index: 1;
  padding: 2px 8px;
  border-radius: 999px;
  font-family: ${theme.typography.fontFamily};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme, $inverted }) =>
    $inverted ? theme.colors.Violet : theme.colors.White};
  background: ${({ theme, $inverted }) =>
    $inverted ? theme.colors.White : theme.colors.Violet};
  border: ${({ theme, $inverted }) =>
    $inverted ? `1px solid ${theme.colors.Violet}40` : 'none'};
  pointer-events: none;
`
